import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';

import Sizes from '../definitions/Sizes';
import Colours from '../definitions/Colours';
import Languages from '../definitions/Languages';
import Config from '../definitions/Config';

import LogoFull from '../graphics/LogoFull';
import getBrandLogo from '../functions/getBrandLogo';
import PageBehaviourButton from './PageBehaviourButton';
import Paragraph from './Paragraph';


function PartnerBannerCanwise({ onClickLanguage, ...otherProps }) {
    const intl = useIntl();
    const languageCode = intl.locale.slice(0, 2);
    const { intrinsicWidth, intrinsicHeight } = getBrandLogo(Config.SITE_BRANDING); // need to access width/height from logo
    const adjustedWidth = intrinsicWidth * 1.3; // 30% wider
    const adjustedHeight = intrinsicHeight * 1.3; // 30% taller

    return (
        <div {...otherProps}>
            <If condition={!!onClickLanguage}>
                <PageBehaviourButton
                    className="language-button"
                    message={
                        languageCode === Languages.FRENCH
                            ? MESSAGES.TOGGLE_ENGLISH
                            : MESSAGES.TOGGLE_FRENCH
                    }
                    onClick={onClickLanguage}
                />
            </If>

            <Paragraph className="description">
                <LogoFull
                    className="logo"
                    width={adjustedWidth}
                    height={adjustedHeight}
                />
                <FormattedMessage
                    id="MortgageLandingPage.customBrandingSubtitle"
                    defaultMessage="CanWise Financial is now Ratehub.ca mortgage brokerage"
                />
            </Paragraph>
        </div>
    );
}

PartnerBannerCanwise.propTypes = {
    onClickLanguage: PropTypes.func,
};

PartnerBannerCanwise.defaultProps = {
    onClickLanguage: undefined,
};

const MESSAGES = defineMessages({
    TOGGLE_ENGLISH: {
        id: 'base-ui.PartnerBannerCanwise.toggleEnglish',
        defaultMessage: 'English',
    },
    TOGGLE_FRENCH: {
        id: 'base-ui.PartnerBannerCanwise.toggleFrench',
        defaultMessage: 'Français',
    },
});

const StyledPartnerBannerCanwise = styled(PartnerBannerCanwise)`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    padding-top: ${Sizes.SPACING.ONE_AND_A_HALF};
    padding-bottom: ${Sizes.SPACING.HALF};

    background-color: ${Colours.STONE_LIGHTEST};
    border-top: thick solid ${Colours.STONE};

    > .language-button {
        align-self: flex-end;

        /* NOTE: negative margin on the bottom to snug it up to the logo */
        margin: 0 calc(${Sizes.SPACING.THREE_QUARTERS} + 5%) -${Sizes.SPACING.ONE} 0;
    }

    > .description {
        display: flex;
        flex-direction: column;

        align-items: center;
        text-align: center;

        margin: ${Sizes.SPACING.QUARTER} 0 ${Sizes.SPACING.ONE};

        > .logo {
            height: ${Sizes.ICONS.XL};
        }
    }
`;

export default StyledPartnerBannerCanwise;
